<template>
    <!-- <van-nav-bar :title="title"
                 :fixed="true">
        <template #left>
            <span class="iconfont icon-xitongfanhui"></span>
        </template>
    </van-nav-bar> -->
    <div>
        <div :class="{'my-nav-bar': true, 'bordered': bordered, 'fixed': fixed}"
             :style="{
                 ...style,
                 'background': this.background,
                 'color': this.textColor}">
            <div class="left" @click="getBack" v-if="$route.path!='/audio/list'">
                <slot name="left" >
                    <span class="iconfont icon-xitongfanhui"></span>
                </slot>
            </div>
            <div class="title">{{title}}</div>
            <div class="right">
                <slot name="right">
                </slot>
            </div>
        </div>
        <div class="place"
             v-if="fixed"></div>
    </div>
</template>
<script>
import { NavBar } from "vant";
export default {
    data() {
        return {
            style: {},
        };
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        showBack: {
            type: Boolean,
            default: true,
        },
        bordered: {
            type: Boolean,
            default: true,
        },
        textColor: {
            type: String,
            default: "#000",
        },
        background: {
            type: String,
            default: "#FFF",
        },
        fixed: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        [NavBar.name]: NavBar,
    },
    created() {
        // 初始化样式
        this.initStyle();
    },
    methods: {
        getBack(){
            this.$router.go(-1)
        },
        initStyle() {
            
            this.style.background = this.background;
            this.style.color = this.textColor;
        },
    },
    watch: {
        background(val){
          if(val){
              this.initStyle()
          }
      },
      textColor(val){
          if(val){
          console.log(val);
          this.initStyle()
          }
      }
    },
};
</script>
<style lang="less" scoped>
.my-nav-bar {
    width: 100%;
    height: 40px;
    display: flex;
    box-sizing: border-box;
    padding: 5px 10px;
    align-items: center;
    justify-content: space-between;
    z-index: 999;
    .iconfont {
        font-size: 18px;
    }
    div {
        flex: 1;
    }
    .title {
        text-align: center;
    }
}
.fixed {
    position: fixed;
    left: 0;
    top: 0;
}
.place {
    width: 100%;
    height: 40px;
}
.bordered {
    border-bottom: 1px solid #eee;
}
.right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>